module.exports = __webpack_public_path__ + "img/discover.ca44ce9c.svg";